import moment from 'moment'
import Vue from 'vue'
import VueI18n from 'vue-i18n'

export const formatDate = (value: Date|string, format:string='DD/MM/YYYY HH:mm',i18n:VueI18n|null=null,utc:boolean=false) => {
  if (value) {    
    moment.locale(i18n?.locale??"fr")    
    return utc?moment(String(value)).utc().format(format):moment(String(value)).format(format)
  }
  return ""
}

Vue.filter('formatDate',formatDate)